import styled, { css } from 'styled-components'

import { InputLabelStyled } from '../../Form/styles/InputLabelStyled'
import { type IFieldProps } from '../Field'

interface IFieldStyledProps {
  layout: IFieldProps['layout']
  error?: IFieldProps['error']
}

export const FieldStyled = styled.div<IFieldStyledProps>`
  width: 100%;

  ${(props) =>
    props.layout === 'vertical'
      ? css`
          > ${InputLabelStyled} {
            display: block;
            margin-bottom: ${props.theme.typography.pxToRem(4)};
          }
        `
      : css`
          display: flex;

          align-items: center;

          > ${InputLabelStyled} {
            white-space: nowrap;
            margin-right: ${props.theme.typography.pxToRem(16)};
            margin-bottom: 0;
            flex: 0 1;
          }
        `}
`
